const mockTransactions = [
  {
    id: 1,
    date: "2026-04-01",
    amount: 5000,
    category: "Salary",
    type: "income"
  },
  {
    id: 2,
    date: "2026-04-02",
    amount: 150,
    category: "Food",
    type: "expense"
  },
  {
    id: 3,
    date: "2026-04-03",
    amount: 200,
    category: "Transport",
    type: "expense"
  },
  {
    id: 4,
    date: "2026-04-04",
    amount: 1000,
    category: "Freelance",
    type: "income"
  },
  {
    id: 5,
    date: "2026-04-05",
    amount: 250,
    category: "Shopping",
    type: "expense"
  },
  {
    id: 6,
    date: "2026-04-01",
    amount: 300,
    category: "Entertainment",
    type: "expense"
  },
  {
    id: 7,
    date: "2026-04-02",
    amount: 1200,
    category: "Investments",
    type: "income"
  },
  {
    id: 8,
    date: "2026-04-01",
    amount: 100,
    category: "Food",
    type: "expense"
  },
  {
    id: 9,
    date: "2026-04-03",
    amount: 180,
    category: "Transport",
    type: "expense"
  },
  {
    id: 10,
    date: "2026-04-04",
    amount: 600,
    category: "Freelance",
    type: "income"
  },
  {
    id: 11,
    date: "2026-04-05",
    amount: 400,
    category: "Shopping",
    type: "expense"
  },
  {
    id: 12,
    date: "2026-04-01",
    amount: 220,
    category: "Entertainment",
    type: "expense"
  }
];

export default mockTransactions;